var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAskAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.492 1.6665H6.50866C3.47533 1.6665 1.66699 3.47484 1.66699 6.50817V13.4832C1.66699 16.5248 3.47533 18.3332 6.50866 18.3332H13.4837C16.517 18.3332 18.3253 16.5248 18.3253 13.4915V6.50817C18.3337 3.47484 16.5253 1.6665 13.492 1.6665ZM14.7253 7.68317C14.567 7.9915 14.2003 8.1165 13.8837 7.9665C12.8587 7.44984 11.7503 7.1665 10.6253 7.08317V13.5748C10.6253 13.9165 10.342 14.1998 10.0003 14.1998C9.65866 14.1998 9.37533 13.9165 9.37533 13.5748V7.08317C8.25033 7.1665 7.14199 7.44984 6.11699 7.9665C6.02533 8.00817 5.92533 8.02484 5.83366 8.02484C5.60866 8.02484 5.38366 7.89984 5.27533 7.68317C5.11699 7.37484 5.24199 6.99984 5.55033 6.8415C8.33366 5.44984 11.6587 5.44984 14.442 6.8415C14.7587 6.99984 14.8837 7.37484 14.7253 7.68317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskAi);
export default __webpack_public_path__ + "static/media/ask-ai.9375fb02aedc77374361449f8d75fb63.svg";
export { ForwardRef as ReactComponent };